@if (isTypeFilter('colors', 'grid')) {
<h-grid-filter-color-and-size [filterGroup]="gridFilterGroup" [isExpanded]="isOpen"> </h-grid-filter-color-and-size>
}

<!--checkbox filters-->
@if (isTypeFilter('list')) {
<h-grid-filter-checkbox [gridFilterGroup]="gridFilterGroup" [isExpanded]="isOpen"> </h-grid-filter-checkbox>
}

<!--slider filters for price-->
@if (isTypeFilter('slider')) {
<h-grid-filters-slider [filterGroup]="gridFilterGroup" [isExpanded]="isOpen"> </h-grid-filters-slider>
}
